import { combineReducers } from 'redux';
import { FETCH_CAPTURES, FETCH_CAPTURES_SUCCESS } from '../actions/capturesRef';

const all = (state = [], action) => {
  switch (action.type) {
    case FETCH_CAPTURES:
      return state;
    case FETCH_CAPTURES_SUCCESS:
      return [...state, action.refs];
    default:
      return state;
  }
};

const isFetching = (state = false, action) => {
  switch (action.type) {
    case FETCH_CAPTURES:
      return true;
    case FETCH_CAPTURES_SUCCESS:
      return false;
    default:
      return state;
  }
};

const capturesRef = combineReducers({
  all,
  isFetching,
});

export default capturesRef;

export const getIsFetching = state => state.manips.capturesRef.isFetching;

export const getCapturesRef = state => state.manips.capturesRef.all[0];



// WEBPACK FOOTER //
// ./src/modules/saas/pco/interventions/manipulations/reducers/capturesRef.js